import { createMentionsConfig } from '@confluence/fabric-media-support/entry-points/MentionsProvider.ts';

type MentionProvider = Awaited<ReturnType<typeof createMentionsConfig>>['mentionResource'];

export const getMentionProvider = (
	cloudId: string,
	environment: string,
	userId: string | null,
): Promise<MentionProvider> => {
	return createMentionsConfig(cloudId, userId)
		.then((config) => config.mentionResource)
		.catch((err) => {
			if (environment !== 'PRODUCTION') {
				// eslint-disable-next-line no-console
				console.error`Failed to initialise mention resource ${err}`;
			}
			return Promise.reject();
		});
};
